import request from '@/utils/request'

// 查询首页菜单列表
export function projectList(query) {
  return request({
    url: '/web/menu/projectlist',
    method: 'get',
    params: query
  })
}

export function getprojectInfo(id) {
  return request({
    url: '/web/menu/projectlist/' + id,
    method: 'get'
  })
}